export default "__VITE_ASSET__DY_HuUNR__"